import alt from 'components/Dispatcher';
import { browserHistory } from 'react-router';
import API from 'sources/API';

class AlbumActions {
    setLoading(loading) {
        return loading;
    }
    cleanAlbumList() {
        return true;
    }
    fetchAlbumList() {
        return true;
    }
    updateAlbumList(albums) {
        return albums;
    }
    fetchUserAlbumList() {
        return true;
    }
    updateUserAlbumList(userAlbums) {
        return userAlbums;
    }
    updateOffset(offset){
        return offset; 
    }
    updateArticleOffset(offset){
        return offset;
    }
    fetchAlbumListSuccess(res) {
        if(res.status === 0) {
            this.updateAlbumList(res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    fetchUserAlbumListSuccess(res) {
        if(res.status === 0) {
            this.updateUserAlbumList(res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    fetchFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }
        return err;
    }
    postAlbum(name) {
        return name;
    }
    deleteAlbum(id){
        return id;
    }
    addAlbum(album) {
        return album;
    }
    updateAlbum(album) {
        return album;
    }
    updateAlbumSuccess(res) {
        if(res.status === 0) {
            browserHistory.goBack();
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    postAlbumSuccess(res) {
        if(res.status === 0) {
            this.addAlbum(res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    deleteAlbumSuccess(res) {
        if(res.status === 0){
            browserHistory.push('/albums');
        }else{
            this.fetchFailed(res);
        }
        return res;
    }
    postAlbumAddMedia(param) { // 把media放入album
        return param;
    }
    postAlbumAddMediaSuccess(res) {
        if(res.status === 0) {
            browserHistory.goBack();
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    fetchAlbumDetail(id) {
        return id;
    }
    fetchAlbumMedia(id) {
        return id;
    }
    fetchAlbumArticleMedia(id) {
        return id;
    }
    cleanAlbumMedia(){
        return true;
    }
    fetchAlbumDetailSuccess(res) {
        if(res.status === 0) {
            this.updateAlbumDetail(res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    updateAlbumMedia(medias) {
        return medias;
    }
    updateAlbumArticleMedia(data){
        return data;
    }
    fetchAlbumMediaSuccess(res) {
        if(res.status === 0) {
            this.updateAlbumMedia(res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    fetchAlbumArticleMediaSuccess(res){
        if(res.status === 0) {
            this.updateAlbumArticleMedia(res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    updateAlbumDetail(album) {
        return album;
    }
    postCollectAlbum(id, type) {
        return {
            id: id,
            type: type
        };
    }
    postCollectAlbumSuccess(res) {
        if(res.status === 0) {
            this.updateIsCollect();
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    updateIsCollect() {
        return true;
    }
    updateFirst(page) {
        return page;
    }
}

export default alt.createActions(AlbumActions);



// WEBPACK FOOTER //
// ./src/actions/AlbumActions.js